var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0be77a5ec28db98df72dbbf1a45aaa7ad808e0f4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["raycast-frontend@raycastapp"]={id:"0be77a5ec28db98df72dbbf1a45aaa7ad808e0f4"};
      